<template>
    <div class="about">
        <div class="header">
            <h1>甘露海</h1>
        </div>
        <h2 style="margin-top:15px">甘露海</h2>
        <p>甘露海，于2013年成立，甘露海中医有限公司旗下品牌，总部位于深圳。目前已发展为一个集医疗健康养生、医疗技术开发为一体的大型综合健康体。</p>
        <div class="item" v-for="item in list" :key="item">
            <p class="fontWeight">{{item.title}}</p>
            <p>{{item.text}}</p>
        </div>
        <div style="margin-top:15px">
            <h3>品牌简介</h3>
            <p>甘露海品牌由黑颈鹤基金管理有限公司主导投资，具有多年藏药现代化研发投资经验，并且掌握医疗行业稀缺资源，致力于推动藏医学普世化和现代化发展。</p>
            <p>甘露海自创立以来，一直秉承“治病养心，乐享健康”的品牌精神，聚集优势病种治疗，采用甘露海三因疗法，通过药物、外治、饮食、起居等综合治疗方案，调节身体机能，协调三因平衡，使身心回归健康。</p>
        </div>
        <div style="margin-top:15px">
            <h3>品牌大事件</h3>
            <p>2021年6月，甘露海联合武汉理工大学共同成立重大疾病与健康研究中心。</p>
        </div>
        <div style="margin-top:15px">
            <h3>品牌业务</h3>
            <p>甘露海致力于成为一家集线下精品实体医院、线上互联网医院 、原药材种植生产基地、现代化制剂中心、大数据健康管理中心、藏医药研究为一体的涵盖医疗产业、医药产业、健康管理服务产业的现代化综合健康体，拥有七大行业第一。</p>
            <ul>
                <li>线下精品实体医院——第一家非民族地区综合性民族医院</li>
                <li>线上互联网医院——第一家获得互联网医院牌照的民族医院</li>
                <li>原药材种植生产基地——第一家于玉树地区实现种植、采集、加工为一体的中藏药材生产基地和饮片加工基地</li>
                <li>现代化制剂中心——第一个获得GMP认证的非民族地区的民族医药制剂</li>
                <li>大数据健康管理中心——第一套从预防、治疗、康复全流程介入的单病种精准健康管理系统</li>
                <li>藏医药研究中心——第一个立足现代科学，从医药化学最前沿理论出发传承并发展藏医药的创新平台</li>
                <li>藏医药文化传媒中心——第一家以藏民族非物质文化遗产为推广载体的国际化传媒平台</li>
            </ul>
        </div>
        <div style="margin-top:15px">
            <h3>品牌文化</h3>
            <ul>
                <li>品牌宗旨：为人民健康服务</li>
                <li>品牌精神：治病养心，乐享健康</li>
                <li>品牌使命：藏医学现代化的践行者、藏医学普世化的创领者。</li>
            </ul>
        </div>
        <div style="margin-top:15px">
            <h3>品牌团队</h3>
            <p>从玉：品牌创始人</p>
            <p>杨宝寿：甘露海藏医院党委书记、院长</p>
            <p>孙涛垒：甘露海董事、首席科学家</p>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                list: [
                    {
                        title: '中文名称：',
                        text: '甘露海'
                    },
                    {
                        title: '外文名称：',
                        text: 'AMRTAN OCEAN'
                    },
                    {
                        title: '所属行业：',
                        text: '中医药'
                    },
                    {
                        title: '品牌使命：',
                        text: '治病养心，乐享健康'
                    },
                    {
                        title: '创始人：',
                        text: '从玉'
                    }
                ]
            }
        }
    }
</script>
<style lang="scss" scoped>
    .about {
        font-size: 16px;
        padding: 15px 30px;
        font-size: #333;
        .header {
            display: flex;
            justify-content: center;
        }
        .item {
            display: flex;
            .fontWeight {
                font-weight: 700;
            }
        }
    }
    ul {
        list-style: disc;
        li {
            font-weight: 700;
        }
    }
</style>
